import React, {useContext, useState} from "react";
import {TouchableOpacity, View} from "react-native";
import PtIcon from "../core/pt-icon/pt-icon";
import {getBankSlip} from "../../actions/duePaymentActions";
import {useSelector} from "react-redux";
import {styleVars} from "../../app-style-vars";
import PtActivityIndicator from "../core/pt-activity-indicator/pt-activity-indicator";
import UserContext from "../../helpers/UserContext";

export default function PtBankSlip(props:any) {

  const {userData, updateUserData} = useContext(UserContext);
  const PTBaseSiteUID = props.baseSiteUID || userData.baseSiteUID;
  const PTSalesAreaDependantCustomerUid = props.salesAreaDependantCustomerUid || userData.salesAreaDependantCustomerUid;
  const currentLanguage = useSelector((state:any) => state.translationsReducer.currentLanguage);

  const [collectingBankSlipData, setCollectingBankSlipData] = useState(false)

  const printBankSlip = () => {
    setCollectingBankSlipData(true);
    getBankSlip(props.payment, PTBaseSiteUID, PTSalesAreaDependantCustomerUid, currentLanguage).then((bankSlipHtml) => {
      const bankSlipWindow = window.open('', 'PRINT', 'height=400,width=600');
      bankSlipWindow.document.write(bankSlipHtml);
      bankSlipWindow.focus(); // necessary for IE >= 10*/
      setTimeout(() => {  //necessary for Chrome
        bankSlipWindow.print();
      }, 250);
    }).finally(() => {
      setCollectingBankSlipData(false);
    })
  }

  return (
    <View>
      <PtActivityIndicator show={collectingBankSlipData}/>
      <TouchableOpacity onPress={() => printBankSlip()}>
        <PtIcon iconName={`print`} iconSize={styleVars.rem(3)} iconColor={styleVars.boschDarkBlue}/>
      </TouchableOpacity>
    </View>
  )

}
